export default __webpack_public_path__ + "static/media/tokenBgMb.82d6f271.png";